<template>
  <div class="lcu-bullet-container">
    <span
      class="lcu-bullet"
      :class="{ 'lcu-bullet-filled': index + 1 <= current }"
      v-for="(bullet, index) in bullets" :key="`${index}-${bullet}`" />
  </div>
</template>

<script>
export default {
  name: 'bullet-legend',
  computed: {
    bullets() {
      return [...Array(this.amount).keys()];
    },
  },
  props: {
    amount: {
      type: Number,
      required: true,
      default: 2,
    },
    current: {
      type: Number,
      required: true,
      default: 1,
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-bullet-container {
  display: flex;
  justify-content: center;
}

.lcu-bullet {
  display: inline-block;
  background-color: $gray-lightest;
  border-radius: 20px;
  height: 10px;
  width: 35px;
  margin-right: 40px;

  &:last-child {
    margin-right: 0;
  }
}

.lcu-bullet-filled {
  background-color: $legacy-primary;
}
</style>
